import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { User, UserConnected, UserStats } from './users.model';
import { AppHttpClientService } from '../shared/app-http-client.service';
import { UserImported } from './import/import.model';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private appHttpClient: AppHttpClientService) {}

  getSessions(auctionId: string) {
    return this.appHttpClient.get<UserStats>('users/stats?auctionId=' + auctionId).toPromise();
  }

  getConnectedUsers(auctionId: string) {
    return this.appHttpClient.get<UserConnected[]>('users/connected?auctionId=' + auctionId).toPromise();
  }

  getAllUsers(term: string, state: string, hasPhone?: boolean, limit?: number) {
    const limitParam = limit !== undefined ? `&limit=${limit}` : '';
    const phoneParam = hasPhone !== undefined ? `&hasPhone=${hasPhone}` : '';
    let url = `users?term=${term}&state=${state}${limitParam}${phoneParam}`;
    
    return this.appHttpClient
      .get<Array<any>>(url)
      .pipe(
        map((users) =>
          users.map(
            (user) =>
              new User(
                user.id,
                user.code,
                user.name,
                user.client,
                user.type,
                user.phone,
                user.email,
                user.state,
                user.canConfirmBid,
                user.isAssisted,
              ),
          ),
        ),
      )
      .toPromise();
  }

  deleteUser(id: string) {
    return this.appHttpClient.delete('user', id);
  }

  deleteAllUsers() {
    return this.appHttpClient.delete('users');
  }

  saveUser(user, isUpdate: boolean) {
    if (isUpdate) {
      return this.appHttpClient.put('users', user);
    }

    return this.appHttpClient.post('users', user);
  }

  enable(id: string, racket: string) {
    return this.appHttpClient.put(`users/enable`, { id, racket });
  }

  disable(id: string) {
    return this.appHttpClient.put(`users/disable`, { id });
  }

  regenerateCodes() {
    return this.appHttpClient.delete('users/codes');
  }

  regenerateRackets() {
    return this.appHttpClient.delete('users/rackets');
  }

  importUsers(users: UserImported[]) {
    const payload = { users: users };
    return this.appHttpClient.post('users/import', payload);
  }
}
